import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import Cookies from 'js-cookie';
import { useContext } from 'react';
import Dexie from 'dexie';
import { deleteAllDatabases } from 'utils/DeleteAllDatabases';

const db = new Dexie('carouselDb');
db.version(1).stores({
  images: '++id, url', // Primary key 'id' is auto-incrementing, and we index the 'url' property
});

const useLogOutUser = (setDrawerOpen) => {
  const GlobalConstants = useContext(GlobalContext);
  const navigate = GlobalConstants.navigate;

  const LogUserOut = async () => {
    try {
      // Delete the carouselDb database
      await db.delete();
      console.log(
        'carouselDb database deleted successfully'
      );
    } catch (err) {
      console.error(
        'Error deleting carouselDb database:',
        err
      );
    }

    // Perform other logout operations
    for (let key in localStorage) {
      if (
        key !== 'UserFont' &&
        key !== 'userColors' &&
        key !== 'UserLanguage' &&
        key !== 'MoreRows' &&
        key !== 'languageArray'
      ) {
        localStorage.removeItem(key);
      }
    }

    localStorage.removeItem('carouselCached');

    navigate({
      pathname: '/Login',
    });

    const cookies = Cookies.get();
    for (const cookie in cookies) {
      Cookies.remove(cookie, {
        path: '/',
        sameSite: 'strict',
        secure: window.top.location.protocol === 'https:',
      });
    }

    sessionStorage.clear();

    deleteAllDatabases();

    setDrawerOpen && setDrawerOpen(false);
  };

  return { LogUserOut };
};

export default useLogOutUser;
